module.exports = __webpack_public_path__ + "static/media/logo_saltala.215b5aba.svg";